import { render, staticRenderFns } from "./RolesTab.vue?vue&type=template&id=3a7eab60&scoped=true"
import script from "./RolesTab.vue?vue&type=script&lang=js"
export * from "./RolesTab.vue?vue&type=script&lang=js"
import style0 from "./RolesTab.vue?vue&type=style&index=0&id=3a7eab60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7eab60",
  null
  
)

export default component.exports